import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrowRight",
  "use": "arrowRight-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrowRight\">\n\t<path d=\"m8.6364 19.545 7.7273-8.6364h-16.364v-1.7838h16.364l-7.7273-8.6708h2.6065l8.7572 9.5455-8.7572 9.5455z\" fill=\"currentColor\" stroke-width=\".90909\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol